import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Sun12pmTo3pm = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00001 1.31598C8.34519 1.31598 8.62501 1.5958 8.62501 1.94098V3.05897C8.62501 3.40415 8.34519 3.68397 8.00001 3.68397C7.65483 3.68397 7.37501 3.40415 7.37501 3.05897V1.94098C7.37501 1.5958 7.65483 1.31598 8.00001 1.31598Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99988 11.6804C10.0325 11.6804 11.6803 10.0326 11.6803 7.99999C11.6803 5.96736 10.0325 4.31958 7.99988 4.31958C5.96725 4.31958 4.31947 5.96736 4.31947 7.99999C4.31947 10.0326 5.96725 11.6804 7.99988 11.6804ZM7.99988 10.4304C9.34216 10.4304 10.4303 9.34227 10.4303 7.99999C10.4303 6.65771 9.34216 5.56958 7.99988 5.56958C6.6576 5.56958 5.56947 6.65771 5.56947 7.99999C5.56947 9.34227 6.6576 10.4304 7.99988 10.4304Z"
        fill="currentColor"
      />
      <path
        d="M8.62501 12.941C8.62501 12.5958 8.34519 12.316 8.00001 12.316C7.65483 12.316 7.37501 12.5958 7.37501 12.941V14.059C7.37501 14.4041 7.65483 14.684 8.00001 14.684C8.34519 14.684 8.62501 14.4041 8.62501 14.059V12.941Z"
        fill="currentColor"
      />
      <path
        d="M14.684 8C14.684 8.34518 14.4041 8.625 14.059 8.625H12.941C12.5958 8.625 12.316 8.34518 12.316 8C12.316 7.65482 12.5958 7.375 12.941 7.375H14.059C14.4041 7.375 14.684 7.65482 14.684 8Z"
        fill="currentColor"
      />
      <path
        d="M3.05897 8.625C3.40415 8.625 3.68397 8.34518 3.68397 8C3.68397 7.65482 3.40415 7.375 3.05897 7.375H1.94098C1.5958 7.375 1.31598 7.65482 1.31598 8C1.31598 8.34518 1.5958 8.625 1.94098 8.625H3.05897Z"
        fill="currentColor"
      />
      <path
        d="M12.7263 3.2737C12.9703 3.51778 12.9703 3.9135 12.7263 4.15758L11.9357 4.94812C11.6916 5.1922 11.2959 5.1922 11.0518 4.94812C10.8078 4.70404 10.8078 4.30832 11.0518 4.06424L11.8424 3.2737C12.0864 3.02962 12.4822 3.02962 12.7263 3.2737Z"
        fill="currentColor"
      />
      <path
        d="M4.94818 11.9358C5.19226 11.6917 5.19226 11.296 4.94818 11.0519C4.7041 10.8078 4.30837 10.8078 4.06429 11.0519L3.27376 11.8424C3.02968 12.0865 3.02968 12.4822 3.27376 12.7263C3.51783 12.9704 3.91356 12.9704 4.15764 12.7263L4.94818 11.9358Z"
        fill="currentColor"
      />
      <path
        d="M12.7263 12.7263C12.4822 12.9704 12.0865 12.9704 11.8424 12.7263L11.0519 11.9358C10.8078 11.6917 10.8078 11.296 11.0519 11.0519C11.2959 10.8078 11.6917 10.8078 11.9357 11.0519L12.7263 11.8424C12.9704 12.0865 12.9704 12.4822 12.7263 12.7263Z"
        fill="currentColor"
      />
      <path
        d="M4.06432 4.94817C4.3084 5.19225 4.70413 5.19225 4.94821 4.94817C5.19228 4.70409 5.19228 4.30836 4.94821 4.06428L4.15767 3.27374C3.91359 3.02967 3.51786 3.02967 3.27378 3.27374C3.02971 3.51782 3.02971 3.91355 3.27378 4.15763L4.06432 4.94817Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Sun12pmTo3pm;
